import React from 'react'
import { cn } from '../utils'

export const MiniBarChart: React.FC<{
    data: number[];
    color?: string;
    height?: number;
    className?: string;
    barWidth?: number;
}> = ({ data, color = 'bg-blue-500', height = 48, className, barWidth = 4 }) => {
    const max = Math.max(...data, 1)
    const min = Math.min(...data, 0)
    const range = max - min || 1
    
    return (
        <div className={cn('flex items-end gap-[3px]', className)} style={{ height }}>
            {data.map((val, i) => {
                const pct = ((val - min) / range) * 100
                const isLast = i === data.length - 1
                
                return (
                    <div
                        key={i}
                        className={cn(
                            'rounded-t-[2px] transition-all duration-300 hover:opacity-80',
                            color,
                            isLast && 'ring-2 ring-offset-1 ring-blue-500/20 dark:ring-offset-gray-900'
                        )}
                        style={{ 
                            width: barWidth, 
                            height: `${Math.max(pct, 4)}%`,
                            opacity: isLast ? 1 : 0.3 + (i / data.length) * 0.5,
                        }}
                        title={`${val.toLocaleString('ru-RU')}`}
                    />
                )
            })}
        </div>
    )
}